import React, { useState } from 'react'
import { CButton, CCol, CImage, CModal, CModalBody, CRow } from '@coreui/react'
import '../../../../components/artistModal/artistModal.scss'
import CodeEditor from '@uiw/react-textarea-code-editor'
import DummyImg from '../../../../assets/no-preview.png'
import HTMl_IMAGE from '../../../../assets/computerp.png'

const EmailModal = (props) => {
  const [code, setCode] = useState(props.body)
  return (
    <CModal scrollable size="xl" visible={true} alignment="top" className="zero-border-modal" show>
      <CModalBody style={{ padding: '0px' }}>
        <img src={HTMl_IMAGE} width={'100%'} height={'100%'} alt={'img'} />
        <div className="container-fluid mt-5 px-4">
          <div className="row">
            <div className="col-md-6">
              <h4 className=" mb-4">Code</h4>
              <div className="card">
                <CRow>
                  <CCol lg="12">
                    <CodeEditor
                      value={code}
                      language="html"
                      placeholder="Please enter HTML code."
                      onChange={(evn) => setCode(evn.target.value)}
                      style={{
                        height: '380px',
                        overflowY: 'scroll',
                        fontSize: 12,
                        backgroundColor: '#000000',
                        color: '#ffffff',
                        fontFamily:
                          'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
                      }}
                    />
                  </CCol>
                </CRow>
              </div>
            </div>
            <div className="col-md-6">
              <h4 className="text-right mb-4">Preview</h4>
              <div className="card preview-card">
                <div
                  className="preview-content"
                  style={{
                    height: '380px',
                    overflowY: 'scroll',
                  }}
                >
                  {code.length === 0 ? (
                    <CImage src={DummyImg} width="100%" height="100%" object-fit="cover" />
                  ) : (
                    <>
                      <div className="preview-html" dangerouslySetInnerHTML={{ __html: code }} />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="w-100 d-flex justify-content-end mt-3 pb-3">
            <CButton
              className="px-3 mx-4 text-black border"
              onClick={() => {
                props.handleChange(code)
                props.handleClose()
              }}
              style={{
                pointerEvents: 'auto',
                fontSize: '18px',
                background: 'inherit',
                border: 'solid 1.5px #bdbdbd',
              }}
            >
              Cancel
            </CButton>
            <CButton
              className="text-white px-3"
              onClick={() => {
                props.handleChange(code)
                props.handleClose(false)
              }}
              style={{ pointerEvents: 'auto', fontSize: '18px', background: '#20211c' }}
            >
              Save Template
            </CButton>
          </div>
        </div>
      </CModalBody>
    </CModal>
  )
}

export default EmailModal
